<template>
  <div class="multiplePrepend-box">
    <div :class="['input1 el-input el-input--mini el-input-group el-input-group--prepend', className]">
      <div class="el-input-group__prepend">
        <span><span class="error">*</span>{{$t('dashboardCont.productkey')}}</span>
      </div>
      <multi-input-tag :placeholder="$i18.language('请输入一个英文产品词')" :disabled="disabled" :id="`keyWord-input`" v-model="params.key" @input="loseBlur('key')"
        :class="{'is-disabled': disabled}" :showSearchType="false" :limit="1" class="allNetKeyWord"></multi-input-tag>
    </div>
    <!-- 类型 -->
    <div :class="['input1 input2 el-input el-input--mini el-input-group el-input-group--prepend']">
      <div class="el-input-group__prepend">
        <span>{{$i18.language('HS编码')}}</span>
      </div>
      <multi-input-tag :minInputLength="4" :maxInputLength="10" :maxInputTips="$i18.language('最多输出十位HS编码!')" :minInputTips="$i18.language('请输入至少四位HS编码!')" :placeholder="$i18.language('至少4位，最多5个')" limitInputType="1" :id="`hscode-input`" :disabled="disabled" v-model="params.hscodes" @input="loseBlur('hscodes')" 
        :class="{'is-disabled': disabled}" :showSearchType="false" :limit="5" class="allNetKeyWord" ></multi-input-tag>
    
    </div>
    <div class="operation-box" @click="operation(selectIndex)" :class="{'is-disabled': disabled}">
      <i :class="[{ 'el-icon-plus': isPlus, 'el-icon-minus': !isPlus }, 'operation-icon']"></i>
    </div>
  </div>
</template>

<script>
import MultiInputTag from '@/views/Trade/components/TradeResults/MultiInputTag'
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selectIndex: {
      type: Number,
      default: 0,
    },
    className: {
      type: String,
      default: '',
    },
    isPlus: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MultiInputTag,
  },
  data() {
    return {
      input1: '',
      options: [],
      hsSplitList: [
        { name: 'OR', id: 1, value: 'or' },
        { name: 'AND', id: 2, value: 'and' },
        { name: 'NOT', id: 3, value: 'not' },
      ]
    }
  },
  created() {
  },
  methods: {
    loseBlur(type) {
      this.$emit('loseBlur', type)
    },
    //点击加减
    operation(index) {
      if(this.disabled) return
      this.$emit('operation', this.isPlus)
    }
  },
}
</script>

<style lang="scss" scoped>
.multiplePrepend-box {
  display: flex;
  flex-direction: row;
  height: 26px;
  margin-bottom: 8px;
  width: 100%;
  align-items: center;
  font-size: $--font-size-base;
  .operation-box {
    width: 26px;
    height: 26px;
    line-height: 26px;
    color: $--color-primary;
    text-align: center;
    margin-left: 5px;
    border-radius: 4px;
    border: 1px solid $--input-border-color;
    cursor: pointer;
  }
  .error {
    color: $--color-danger !important;
    margin-right: 3px;
  }
  // :deep(.el-input-group__prepend){
  //   width: 64px;
  //   min-width: min-content;
  // }
  .input1 {
    display: flex;
    flex-direction: row;
    // width: calc(100% - 21px);
    // border-radius: 4px;

    // display: inline-flexbox !important;
    // height: 28px;
    /deep/.el-input__inner {
      border-radius: 0%;
    }
    /deep/.el-input-group__prepend {
      display: inline-table;
      line-height: 26px;
      // width:64px;
      // line-height: 28px;
    }
    .allNetKeyWord {
      width: 100%;
      overflow: hidden;
    }
    /deep/ #keyWord-input {
      justify-content: space-between;
      border-radius: 0%;
      border-color: #dcdfe6;
      // width: calc(100%  - 105.67px);
      .new-tag {
        font-size: 12px !important;
        line-height: 26px;
      }
    }
  }
  .input2 {
    // height: 28px;
    /deep/.el-input-group__prepend {
      border-left: none !important;
      border-radius: 0%;
    }
  }
  /deep/.vue-input-tag-wrapper .input-tag {
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    color: #909399;
    margin: 2px 0 2px 6px;
    box-sizing: border-box;
    display: flex;
    max-width: 98%;
    align-items: center;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    display: inline-flex;
    font-size: 12px;
    white-space: nowrap;
    height: 20px;
    padding: 0 5px;
    line-height: 19px;
    &.select-tag {
      border: 2px solid #ea5519;
      color: #ea5519;
      .remove {
        color: #ea5519;
      }
    }
  }
  /deep/.views_tag {
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .first-box,
  .second-box {
    width: 49%;
  }
  .second-box {
    font-size: 12px;
    display: flex;
    flex-direction: row;
  }
  .input-with-select {
    width: 100%;
  }
  .hsCode-box {
    width: 100%;
  }
}
.socialKeyWord-input {
  width: calc(100% - 21px);
  /deep/#keyWord-input {
    border-top-right-radius: 4px !important; /* 设置右上角圆角 */
    border-bottom-right-radius: 4px !important; /* 设置右下角圆角 */
  }
  /deep/.allNetKeyWord {
    width: calc(100% - 105.67px) !important;
  }
}
.dealKeyWord-input {
  width: calc((100% - 21px) / 2);
  box-sizing: border-box;
  /deep/.allNetKeyWord {
    width: calc(100% - 105.67px) !important;
    box-sizing: border-box;
    .vue-input-tag-wrapper {
      border-right: none !important;
    }
  }
}
.allNetKeyWord-input {
  // width: calc((100% - 23px) / 2);
  width: 48%;
  box-sizing: border-box;
  /deep/.allNetKeyWord {
    // width: calc(100% - 105.67px) !important;
    box-sizing: border-box;
  }
}
.input2 {
  // width: calc((100% - 24px) / 2) !important;
  width: 48%;
}
/deep/.vue-input-tag-wrapper {
  height: 26px;
  border-radius: 0 4px 4px 0;
}
.is-disabled {
  color: #C0C4CC !important;
  cursor: not-allowed !important;
  background-color: #EFF1F2 !important;
  border-color: #d8dee6 !important;
}
:deep(.vue-input-tag-wrapper .input-tags-box-unfold){ //展开
    white-space: nowrap;
    max-width: 99% !important;
  }
.hsCode-box {
  /deep/.el-input-group__prepend {
    .el-input .el-input__inner {
      border-top-right-radius: 0% !important;
      border-bottom-right-radius: 0% !important;
      border-right: none !important;
    }
  }
}
/deep/ .text-btn {
  color: #909399;
}
</style>
